import React, { Component } from 'react';
import { Button, Select } from 'antd';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import { DefaultList } from '../../../constants';

const { Option } = Select;

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expand: false,
            msgList: [],
        };
    }

    componentDidMount() {
        this.queryMsgList();
    }

    queryMsgList = () => {
        Fetch.post(API_URL.requestDataAnalysis.querySearchTitle).then(res => {
            const { data } = res;
            this.setState({
                msgList: data || [],
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    search = () => {
        this.props.search();
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render () {
        const { searchParams } = this.props;
        const { expand, msgList } = this.state;

        const defaultOption = msgList.map(i => <Option key={i.ids}>{i.typeValue}</Option>);
        return (
            <div style={{ marginBottom: 16 }}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`}>
                    {/* <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div> */}
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">消息类型</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 240}}
                            value={searchParams.ids}
                            onChange={value => this.handleChange(value, 'ids')}
                        >
                            {defaultOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestInfo/RequestMessage/TablePage/Filter.js